<template>
  <section class="table-section disp-scroll">
    <table class="sended-list-table" border="1">
      <tr class="table-header">
        <th class="sender">送信者</th>
        <th class="content">メッセージ</th>
        <th class="timestamp">送信日時</th>
      </tr>
      <template v-for="(message, i) in sortedLineMessageList">
        <tr :key="i">
          <td>{{ sender(message) }}</td>
          <td>{{ message.content }}</td>
          <td>{{ formatTime(message.timestamp) }}</td>
        </tr>
      </template>
    </table>
  </section>
</template>

<script>
export default {
  props: {
    lineMessageList: {
      type: Array,
      required: false,
    },
  },
  computed: {
    sortedLineMessageList() {
      if (!this.$props.lineMessageList || !Array.isArray(this.$props.lineMessageList)) {
        return []
      }
      // 配列をコピーしてソート（元の配列を変更しない）
      return [...this.$props.lineMessageList].sort((a, b) => {
        // ISO 8601形式の文字列は直接比較可能
        return b.timestamp.localeCompare(a.timestamp)
      })
    },
  },
  methods: {
    sender(message) {
      return message.from_user ? "ユーザー" : "ボットサーバー"
    },
    formatTime(createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    },
    sendOrReceive(flg) {
      if (flg) {
        return "受信"
      } else {
        return "送信"
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.table-section {
  overflow: auto;
  max-height: 350px;
}

.table-section::-webkit-scrollbar {
  //width: 5px;
}

.sended-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;

  th,
  td {
    padding: 8px;
  }

  .sender {
    width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .content {
    // width: 120px;
  }

  .timestamp {
    width: 160px;
  }
}

.empty-tr {
  height: 36px;
}

td {
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/tables/LINELogTable.vue